import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["urlField"]

  connect() {
    this.update()
  }

  update() {
    const release = this.element.querySelector('input[name="author_document[reading_mode]"]:checked')?.value
    const fullChecked = this.element.querySelector('input[type="checkbox"][name="author_document[full_version]"]')?.checked
    const show = ["normal", "micro_feedback"].includes(release) && !fullChecked

    if (this.hasUrlFieldTarget) {
      this.urlFieldTarget.classList.toggle("hidden", !show)
    }
  }
}